import { OMSEventType } from "@redotech/redo-fulfillment-group-common/fulfillment-group-events";
import { OMSMetricsResponseSchema } from "@redotech/redo-model/fulfillments/metrics";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getEventTypeCount = {
  name: "getEventTypeCount" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    eventTypes: z.array(createEnum(OMSEventType)),
  }),
  output: OMSMetricsResponseSchema,
};
